import { gql } from '@apollo/client';

export type CreditSubmarketProps = 'S' | 'SE' | 'N' | 'NE';

export interface CreditCounterpartListFilterProps {
  counterpartName?: string;
  rating?: string;
  hasExposure?: boolean;
  startCompetence?: string;
  endCompetence?: string;
}

export interface CreditCounterpartyProps {
  __typename?: 'Counterpart';
  accountId: string;
  counterpartName: string;
  taxId?: string;
  rating?: string;
  negotiationDeadlineLabel?: string;
  exposureMtmFiltered: number;
  exposureMtmGlobal: number;
  limitAverage: number;
  financialBalance: number;
}

export interface PayloadProps {
  filter?: CreditCounterpartListFilterProps;
}

export interface ResponseProps {
  creditCounterpartList: CreditCounterpartyProps[];
}

const CREDIT_COUNTERPARTY_FRAGMENT = gql`
  fragment creditCounterparty on Counterpart {
    accountId
    counterpartName
    taxId
    rating
    negotiationDeadlineLabel
    exposureMtmFiltered
    exposureMtmGlobal
    limitAverage
    financialBalance
  }
`;

const CREDIT_COUNTERPART_LIST = gql`
  ${CREDIT_COUNTERPARTY_FRAGMENT}

  query creditCounterpartList($filter: CreditCounterpartListFilter) {
    creditCounterpartList(filter: $filter) {
      ...creditCounterparty
    }
  }
`;

export { CREDIT_COUNTERPARTY_FRAGMENT };
export default CREDIT_COUNTERPART_LIST;
